var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 5.39062 5.84375 0 12.5 0C19.1094 0 24.5 5.39062 24.5 12C24.5 18.6562 19.1094 24 12.5 24C5.84375 24 0.5 18.6562 0.5 12ZM17.0469 7.45312C16.7656 7.17188 16.2969 7.07812 15.9219 7.21875L6.73438 11.1562C6.26562 11.3438 6.03125 11.8594 6.125 12.3281C6.21875 12.7969 6.64062 13.125 7.10938 13.125H11.375V17.3438C11.375 17.8594 11.7031 18.2812 12.1719 18.375C12.2656 18.375 12.3125 18.375 12.3594 18.375C12.7812 18.375 13.1562 18.1406 13.3438 17.7656L17.2812 8.57812C17.4219 8.20312 17.3281 7.73438 17.0469 7.45312Z",
    fill: "#1D4F8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreet);
export default __webpack_public_path__ + "static/media/street.425698ad58d73eaf23be55229ff444fd.svg";
export { ForwardRef as ReactComponent };